import { Component, inject } from '@angular/core'
import { ErpKeycloakService } from '@shared/services/erp-keycloak/erp-keycloak.service'
@Component({
  selector: 'app-root',
  standalone: false,
  template: `<router-outlet/>`
})
export class AppComponent {
  private readonly keycloak = inject(ErpKeycloakService)
  constructor() {  this.keycloak.setUser() }
}